module.exports = __webpack_public_path__ + "static/media/megara-lose.43b3a2ae.png";